import request from '@/request'

export async function getIndex () {
  const response = await request({
    url: `/course-categories`,
    method: 'get'
  })

  return response.data.data
}

export async function getCategoryCourses (id, params) {
  const response = await request({
    url: `/course-categories/${id}/courses`,
    method: 'get',
    params,
  })

  return response.data
}